const data = [
  {
    id: 1,
    image: "assets/img/website/thumbs/northmanenergy.avif",
    fullImage: "assets/img/website/full/northmanenergy.avif",
    alt: "Energy Solutions Website Design",
    category: "Website Development"
  },
    {
    id: 1,
    image: "assets/img/website/thumbs/ahlanventureconsulting.avif",
    fullImage: "assets/img/website/full/ahlanventureconsulting.avif",
    alt: "Consulting Website Design",
    category: "Website Development"
  },
  
  {
    id: 2,
    image: "assets/img/website/thumbs/omoikaneinnovations.avif",
    fullImage: "assets/img/website/full/omoikaneinnovations.avif",
    alt: "Tech Startup Website Design",
    category: "Website Development"
  },
  {
    id: 3,
    image: "assets/img/website/thumbs/parashomestate.avif",
    fullImage: "assets/img/website/full/parashomestate.avif",
    alt: "Real Estate Developer Website",
    category: "Website Development"
  },
  {
    id: 4,
    image: "assets/img/website/thumbs/anilmandhani.avif",
    fullImage: "assets/img/website/full/anilmandhani.avif",
    alt: "Doctor Portfolio Website Design",
    category: "Website Development"
  },
  {
    id: 5,
    image: "assets/img/website/thumbs/dreamfitgymnastics.avif",
    fullImage: "assets/img/website/full/dreamfitgymnastics.avif",
    alt: "Fitness and Gymnastics Website",
    category: "Website Development"
  },
  {
    id: 6,
    image: "assets/img/website/thumbs/mjlawfirms.avif",
    fullImage: "assets/img/website/full/mjlawfirms.avif",
    alt: "Law Firm Website Design",
    category: "Website Development"
  },
  {
    id: 7,
    image: "assets/img/website/thumbs/ektamission.avif",
    fullImage: "assets/img/website/full/ektamission.avif",
    alt: "NGO and Charity Website",
    category: "Website Development"
  },
  {
    id: 8,
    image: "assets/img/website/thumbs/bigearastrology.avif",
    fullImage: "assets/img/website/full/bigearastrology.avif",
    alt: "Online Astrology Consultation Website",
    category: "Website Development"
  },
  {
    id: 9,
    image: "assets/img/website/thumbs/carrevives.avif",
    fullImage: "assets/img/website/full/carrevives.avif",
    alt: "Car Repair Services Website",
    category: "Website Development"
  },
  {
    id: 10,
    image: "assets/img/website/thumbs/musictek.avif",
    fullImage: "assets/img/website/full/musictek.avif",
    alt: "Music Technology Company Website",
    category: "Website Development"
  },
  {
    id: 11,
    image: "assets/img/website/thumbs/rentbaazar.avif",
    fullImage: "assets/img/website/full/rentbaazar.avif",
    alt: "Online Rental Platform Website",
    category: "Website Development"
  },
  {
    id: 12,
    image: "assets/img/website/thumbs/datcoanalytics.avif",
    fullImage: "assets/img/website/full/datcoanalytics.avif",
    alt: "Analytics and Data Services Website",
    category: "Website Development"
  },
  {
    id: 13,
    image: "assets/img/website/thumbs/altusbiotech.avif",
    fullImage: "assets/img/website/full/altusbiotech.avif",
    alt: "Biotech Company Website",
    category: "Website Development"
  },
  {
    id: 14,
    image: "assets/img/website/thumbs/greatindiankitchen.avif",
    fullImage: "assets/img/website/full/greatindiankitchen.avif",
    alt: "Food and Recipe Blog Website",
    category: "Website Development"
  },
  {
    id: 15,
    image: "assets/img/website/thumbs/inayadecors.avif",
    fullImage: "assets/img/website/full/inayadecors.avif",
    alt: "Interior Decorator Website",
    category: "Website Development"
  },
  {
    id: 16,
    image: "assets/img/website/thumbs/intervuequestions.avif",
    fullImage: "assets/img/website/full/intervuequestions.avif",
    alt: "Interview Preparation and Questions Portal",
    category: "Website Development"
  },
  {
    id: 17,
    image: "assets/img/website/thumbs/latestbhojpuriya.avif",
    fullImage: "assets/img/website/full/latestbhojpuriya.avif",
    alt: "Bhojpuri News & Entertainment Portal",
    category: "Website Development"
  },
  {
    id: 18,
    image: "assets/img/website/thumbs/likeyourtravelagency.avif",
    fullImage: "assets/img/website/full/likeyourtravelagency.avif",
    alt: "Travel Agency Website",
    category: "Website Development"
  },
  {
    id: 19,
    image: "assets/img/website/thumbs/mr-electricals.avif",
    fullImage: "assets/img/website/full/mr-electricals.avif",
    alt: "Electrical Products Business Website",
    category: "Website Development"
  },
  {
    id: 20,
    image: "assets/img/website/thumbs/cheapflightsprices.avif",
    fullImage: "assets/img/website/full/cheapflightsprices.avif",
    alt: "Flight Booking Deals Website",
    category: "Website Development"
  },
  {
    id: 21,
    image: "assets/img/website/thumbs/newrx.avif",
    fullImage: "assets/img/website/full/newrx.avif",
    alt: "Medical Prescription Services Website",
    category: "Website Development"
  },
  {
    id: 22,
    image: "assets/img/website/thumbs/nurs.avif",
    fullImage: "assets/img/website/full/nurs.avif",
    alt: "Nursing and Healthcare Website",
    category: "Website Development"
  },
  {
    id: 23,
    image: "assets/img/website/thumbs/om.avif",
    fullImage: "assets/img/website/full/om.avif",
    alt: "Spiritual or Religious Website",
    category: "Website Development"
  },
  {
    id: 24,
    image: "assets/img/website/thumbs/ornatiquepremium.avif",
    fullImage: "assets/img/website/full/ornatiquepremium.avif",
    alt: "Jewellery eCommerce Website",
    category: "Website Development"
  },
  {
    id: 25,
    image: "assets/img/website/thumbs/rkengineeringservices.avif",
    fullImage: "assets/img/website/full/rkengineeringservices.avif",
    alt: "Engineering Services Website",
    category: "Website Development"
  },
  {
    id: 26,
    image: "assets/img/website/thumbs/sadafaldev.avif",
    fullImage: "assets/img/website/full/sadafaldev.avif",
    alt: "Spiritual Guru Website",
    category: "Website Development"
  },
  {
    id: 27,
    image: "assets/img/website/thumbs/sargamarts.avif",
    fullImage: "assets/img/website/full/sargamarts.avif",
    alt: "Online Music Accessories Store",
    category: "Website Development"
  },
  {
    id: 28,
    image: "assets/img/website/thumbs/sarvapaints.avif",
    fullImage: "assets/img/website/full/sarvapaints.avif",
    alt: "Paint Company Website",
    category: "Website Development"
  },
  {
    id: 29,
    image: "assets/img/website/thumbs/space-design.avif",
    fullImage: "assets/img/website/full/space-design.avif",
    alt: "Architecture and Design Website",
    category: "Website Development"
  },
  {
    id: 30,
    image: "assets/img/website/thumbs/sssvvdel.avif",
    fullImage: "assets/img/website/full/sssvvdel.avif",
    alt: "Spiritual Organization Website",
    category: "Website Development"
  },
  {
    id: 31,
    image: "assets/img/website/thumbs/stylewithglamour.avif",
    fullImage: "assets/img/website/full/stylewithglamour.avif",
    alt: "Fashion and Style Blog Website",
    category: "Website Development"
  },
  {
    id: 32,
    image: "assets/img/website/thumbs/swamirangnathacharya.avif",
    fullImage: "assets/img/website/full/swamirangnathacharya.avif",
    alt: "Hindu Scholar Website",
    category: "Website Development"
  },
  {
    id: 33,
    image: "assets/img/website/thumbs/thetripcompany.avif",
    fullImage: "assets/img/website/full/thetripcompany.avif",
    alt: "Travel and Tour Services Website",
    category: "Website Development"
  },
  {
    id: 34,
    image: "assets/img/website/thumbs/dashcorporation.avif",
    fullImage: "assets/img/website/full/dashcorporation.avif",
    alt: "Corporate Business Website",
    category: "Website Development"
  }
];

export default data;
